"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionEditState = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var services_1 = require("../services");
var collection_edit_model_1 = require("../store/collection.edit.model");
var page_state_1 = require("./page.state");
var CollectionEditState = /** @class */ (function () {
    function CollectionEditState(collection) {
        this.collectionRevision = null;
        this.collection = null;
        this.draw = mobx_1.observable.map({}, { deep: false });
        if (collection == null) {
            this.collectionRevision = null;
            return;
        }
        this.collectionRevision = collection.revision;
        this.editState = collection.beginEdit(function (state) { return new collection_edit_model_1.CollectionModelStateEdit(state); });
        this.collection = collection;
    }
    CollectionEditState.prototype.reset = function () {
        var _a;
        (_a = this.editState) === null || _a === void 0 ? void 0 : _a.reset();
    };
    CollectionEditState.prototype.revert = function (fieldId) {
        var _a;
        (_a = this.editState) === null || _a === void 0 ? void 0 : _a.fields.delete(fieldId);
    };
    CollectionEditState.prototype.isFieldDirty = function (fieldId) {
        var _a;
        return (_a = this.editState) === null || _a === void 0 ? void 0 : _a.fields.has(fieldId);
    };
    Object.defineProperty(CollectionEditState.prototype, "isDirty", {
        get: function () {
            var _a;
            return this.collectionRevision != null && ((_a = this.editState) === null || _a === void 0 ? void 0 : _a.isDirty);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionEditState.prototype, "isEditing", {
        get: function () {
            return this.collectionRevision != null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionEditState.prototype, "currentDraw", {
        get: function () {
            var inspectedCapture = page_state_1.CurrentState.inspectedCaptureId;
            if (inspectedCapture == null) {
                return null;
            }
            return this.getIkeDraw(inspectedCapture);
        },
        enumerable: false,
        configurable: true
    });
    CollectionEditState.prototype.getIkeDraw = function (captureId) {
        var existing = this.draw.get(captureId);
        if (existing != null) {
            return existing;
        }
        if (!this.collection) {
            throw new Error('Collection must be set before getting IkeDraw from CollectionEditState');
        }
        var drawState = services_1.Services.DrawState.createIkeDraw(this.collection, captureId);
        this.draw.set(captureId, drawState);
        return drawState;
    };
    CollectionEditState.prototype.cancelLinkFields = function () {
        this.draw.forEach(function (draw) { return draw.state.setLinkFields(null); });
    };
    tslib_1.__decorate([
        mobx_1.action
    ], CollectionEditState.prototype, "reset", null);
    tslib_1.__decorate([
        mobx_1.action
    ], CollectionEditState.prototype, "revert", null);
    return CollectionEditState;
}());
exports.CollectionEditState = CollectionEditState;
//# sourceMappingURL=collection.edit.state.js.map